import { LocationNumbersService } from "../../../services"

const checkAvailableNumbers = async function(_, config) {
  const { locationId, payload } = config
  try {
    const { data } = await LocationNumbersService.checkAvailableNumbers(
      locationId, payload
    )

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default checkAvailableNumbers
